// Module: Content Accuracy
import React from 'react'

import Module from 'components/Module'

export default (props: any) => (
  <Module title="Content Accuracy" load={() => import('./module')} {...props} />
)
